export default __webpack_public_path__ + "static/iphonex-truaccent-a4e6591fc52219bc589a5fc4ac767f00.png";